export default __webpack_public_path__ + "static/media/review7.c72e82fe.jpg";